import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import dt from '../../shared/theme';

const size = 50;

const turnLeft = keyframes`
  0% {
    width: 38px;
    margin-left: 0px;
    margin-right: 0px;
  }

  25% {
    width: 0px;
    margin-left: 0px;
    margin-right: 38px;
  }

  50% {
    width: 19px;
    margin-left: 9.5px;
    margin-right: 9.5px;
  }

  75% {
    width: 0px;
    margin-left: 38px;
    margin-right: 0px;
  }

  100% {
    width: 38px;
    margin-left: 0px;
    margin-right: 0px;
  }
`;

const turnRight = keyframes`
  0% {
    width: 38px;
    margin-left: 0px;
    margin-right: 0px;
  }

  25% {
    width: 0px;
    margin-left: 38px;
    margin-right: 0px;
  }

  50% {
    width: 19px;
    margin-left: 9.5px;
    margin-right: 9.5px;
  }

  75% {
    width: 0px;
    margin-left: 0px;
    margin-right: 38px;
  }

  100% {
    width: 38px;
    margin-left: 0px;
    margin-right: 0px;
  }
`;

const Container = styled.div`
  margin: ${props => (dt(props).theme.isMobile ? 12 : 52)}px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${size}px;

  > hr {
    width: 38px;
    margin: 0;
    border: none;
    border-bottom: 1px solid ${props => dt(props).theme.primaryColor};

    ${props => dt(props).animate === 'true' && `
      &:first-child {
        animation: ${turnLeft} 1s cubic-bezier(1, 0, 0, 1) infinite;
      }
      &:last-child {
        animation: ${turnRight} 1s cubic-bezier(1, 0, 0, 1) infinite;
      }
    `};
  }

  > span {
    text-align: center;
    font-size: 32px;
    width: ${size}px;
    &:before {
      color: ${props => dt(props).theme.secondaryColorLight};
    }
  }
`;

export default function LogoSeparator({ animate }) {
  return (
    <Container>
      <hr animate={animate.toString()} />
      <span className="icon-lw icon-lw-logo" />
      <hr animate={animate.toString()} />
    </Container>
  );
}

LogoSeparator.propTypes = {
  animate: PropTypes.bool,
};

LogoSeparator.defaultProps = {
  animate: false,
};
